import API from "utils/API";
import authHeader from "utils/auth-header";
import { IGetExpensesResponse } from "../domain/IGetExpensesResponse";
import { IExpense } from "../domain/IExpense";
import { IUpdatePaymentRequestParams } from "../domain/IUpdatePaymentRequestParams";
import { IUpdateExpenseRequestParams } from "../domain/IUpdateExpenseRequestParams";
import { ICreateExpenseRequestParams } from "../domain/ICreateExpenseRequestParams";
import { ICreatePaymentRequestParams } from "../domain/ICreatePaymentRequestParams";
import { IMessage } from "domain/IMessage";
import { IExpenseSearch } from "../domain/IExpenseSearch";
import { getQeuryParams } from "utils/queryParamsUtil";

const getAllExpenses = async (
  data?: IExpenseSearch
): Promise<IGetExpensesResponse> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetExpensesResponse>(
      `/expenses/protected/expense${getQeuryParams(data)}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

const createExpense = async (data: ICreateExpenseRequestParams): Promise<IExpense> => {
  var headers = authHeader();
  try {
    const response = await API.post<IExpense>(
      `/expenses/protected/expense`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const updateExpense = async (expenseId: number, data: IUpdateExpenseRequestParams): Promise<IExpense> => {
  var headers = authHeader();
  try {
    const response = await API.put<IExpense>(
      `/expenses/protected/expense/${expenseId}`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const createPayment = async (expenseId: number, data: ICreatePaymentRequestParams): Promise<IExpense> => {
  var headers = authHeader();
  try {
    const response = await API.post<IExpense>(
      `/expenses/protected/expense/${expenseId}/payment`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const updatePayment = async (expenseId: number, paymentId: number, data: IUpdatePaymentRequestParams): Promise<IExpense> => {
  var headers = authHeader();
  try {
    const response = await API.put<IExpense>(
      `/expenses/protected/expense/${expenseId}/payment/${paymentId}`,
      data,
      { headers }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteExpense = async (expenseId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/expenses/protected/expense/${expenseId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
}

const deletePayment = async (
  expenseId: number, paymentId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.delete<IMessage>(
      `/expenses/protected/expense/${expenseId}/payment/${paymentId}`,
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
}

export const expensesService = {
  getAllExpenses,
  createExpense,
  updateExpense,
  createPayment,
  updatePayment,
  deleteExpense,
  deletePayment
};
